<template>
  <div id="app">
    <ReactiveBase
      credentials="7x2KuCEco:0c490cf7-2f5d-41fd-bc44-22d7d90659d7"
      app="Movies_JY"
    >
      <template v-if="$route.matched.length">
        <router-view></router-view>
      </template>
    </ReactiveBase>
    <div class="footer">
      <p>
        This app is part of the ReactiveSearch Marketplace. You can check more
        apps <a href="https://reactiveapps.io" target="_blank">here</a>.
      </p>
      <a
        href="https://gumroad.com/l/HyNhh?wanted=true"
        class="button"
        target="_blank"
      >
        Buy Now for $49
      </a>
    </div>
  </div>
</template>

<script>
import "./styles.css";
export default {
  name: "app"
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
